import { Grid, makeStyles, Box, Typography } from '@material-ui/core'
import React from 'react'

import colors from '../../../assets/colors'

import ImportantInfo from './Forms/ImportantInfo'

const FAQ_TOPICS = [
  {
    topic: 'Assinatura',
    faqs: [
      {
        question: 'Como funciona a assinatura?',
        answer:
          'O plano é pré-pago: a fatura de cada ciclo é gerada no começo dele, já com o plano e os serviços adicionais ativos. Como o ciclo corrente já está pago, nada que você faça no meio dele altera essa fatura.',
      },
      {
        question: 'Como funciona o limite de usuários do plano?',
        answer:
          'Cada plano inclui uma quantidade de vagas de usuário ativo. O painel "Usuários" mostra de onde vêm as suas vagas (as incluídas no plano e as do adicional "Usuário extra" que você contratou), quantas estão em uso e quantas estão livres. Para ativar mais usuários do que o plano permite, contrate o serviço adicional "Usuário extra" e informe a quantidade de vagas necessárias. Usuários inativos não ocupam vaga.',
      },
      {
        question: 'Quando a próxima fatura é gerada?',
        answer:
          'No início de cada ciclo, já considerando o plano e os serviços adicionais que estarão ativos no período. Serviços contratados no meio do ciclo são cobrados à parte, em uma cobrança proporcional aos dias restantes.',
      },
      {
        question: 'É possível emitir nota fiscal dos pagamentos?',
        answer:
          'Sim, a nota fiscal é emitida automaticamente e disponibilizada no histórico de pagamentos.',
      },
    ],
  },
  {
    topic: 'Cartão',
    faqs: [
      {
        question: 'Os dados do meu cartão estão seguros?',
        answer:
          'Sim. Seguindo as normas da LGPD (Lei Geral de Proteção de Dados) e o padrão de segurança PCI-DSS, os dados do cartão são enviados de forma criptografada diretamente ao nosso processador de pagamentos (Pagar.me) e não são armazenados em nossos servidores. Em nosso sistema, guardamos apenas informações não sensíveis, como a bandeira, os últimos 4 dígitos e a data de validade, usadas para identificar o cartão.',
      },
      {
        question: 'Como altero o cartão de cobrança da minha assinatura?',
        answer:
          'Cadastre um novo cartão na seção "Cartões" e selecione-o como método de pagamento principal.',
      },
      {
        question: 'O que acontece se o pagamento da fatura falhar?',
        answer:
          'Você será notificado e terá um prazo para regularizar o pagamento antes da suspensão da assinatura.',
      },
      {
        question: 'Como funciona o pagamento via boleto?',
        answer:
          'Ao escolher boleto como método de pagamento, o documento é gerado para quitação da fatura. Lembre-se de que boletos podem levar até 3 dias úteis para serem compensados, por isso pague com antecedência para evitar a suspensão da assinatura. Ao contratar um serviço adicional (ou aumentar a quantidade) no meio do ciclo, também é gerada uma cobrança do valor proporcional aos dias restantes — o acesso é liberado na hora, mas essa cobrança precisa ser paga.',
      },
    ],
  },
  {
    topic: 'Serviços adicionais',
    faqs: [
      {
        question: 'Como faço para contratar um novo serviço?',
        answer:
          'Você pode contratar diretamente nessa mesma seção e a liberação é instantânea. Nos serviços cobrados por unidade, informe a quantidade desejada no campo ao lado antes de ligar o serviço: assim tudo é contratado de uma vez e gera uma única cobrança proporcional.',
      },
      {
        question: 'O valor do plano muda ao contratar novos serviços?',
        answer:
          'Sim, o valor é recalculado automaticamente conforme os serviços adicionados ou removidos do plano.',
      },
      {
        question: 'Como funcionam os serviços cobrados por quantidade?',
        answer:
          'Alguns serviços adicionais são cobrados por unidade. O valor exibido é o preço unitário e o total é multiplicado pela quantidade contratada. Informe a quantidade já na contratação para gerar uma cobrança só. Aumentar a quantidade depois é liberado a qualquer momento e você paga na hora apenas o proporcional aos dias que faltam do ciclo, em uma nova cobrança. Reduzir também é liberado a qualquer momento: a quantidade atual continua liberada até o fim do ciclo já pago, e a redução aparece na próxima fatura.',
      },
      {
        question:
          'Posso reduzir a quantidade de um serviço a qualquer momento?',
        answer:
          'Sim, a qualquer momento. A redução passa a valer no fim do ciclo já pago: até lá você continua com a quantidade atual, e a próxima fatura já vem com a quantidade reduzida. Não há devolução do valor já pago neste ciclo. Enquanto a mudança não entra em vigor, o serviço mostra as duas quantidades (a em uso e a que passará a valer, com a data).',
      },
      {
        question:
          'Contratar um serviço no meio do ciclo é cobrado proporcionalmente?',
        answer:
          'Sim. Como o ciclo corrente já está pago, ao contratar um serviço (ou aumentar a quantidade) é gerada na hora uma cobrança avulsa apenas do proporcional aos dias que faltam para o fim do ciclo. Do ciclo seguinte em diante, o serviço entra normalmente na fatura. Em cartão a cobrança é aprovada na hora; em boleto, um boleto é gerado com vencimento em 5 dias e o acesso é liberado de imediato.',
      },
      {
        question:
          'Por que alguns serviços aparecem com desconto ou como grátis?',
        answer:
          'Determinados serviços podem ter desconto ou isenção aplicados à sua conta, seja por condição comercial ou por regras do plano (por exemplo, gratuidade a partir de uma certa quantidade de usuários). Nesses casos, o benefício aparece indicado no próprio serviço.',
      },
    ],
  },
  {
    topic: 'Cancelamento',
    faqs: [
      {
        question: 'Como funciona o cancelamento da assinatura?',
        answer:
          'O cancelamento da assinatura revoga todas as suas permissões de uso até realizar a contratação novamente. Qualquer atividade suspeita será passível a inativação do uso.',
      },
      {
        question: 'Posso cancelar um serviço contratado a qualquer momento?',
        answer:
          'Sim, a qualquer momento. O serviço fica com o status "Cancelamento agendado" e você continua usando até o fim do ciclo já pago; a cobrança sai da próxima fatura. Não há devolução do valor já pago neste ciclo. Em caso de cancelamento imediato será necessário a análise do suporte.',
      },
    ],
  },
]

const useStyles = makeStyles({
  card: {
    border: '1px solid',
    borderColor: colors.graylight,
    padding: '20px 16px',
    borderRadius: '12px',
  },
  cardTitle: {
    fontSize: '20px',
    color: colors.primary,
    fontWeight: 'bold',
  },
  topicTitle: {
    fontSize: '14px',
    fontWeight: 'bold',
    color: colors.textCustom,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
})

const Help = () => {
  const classes = useStyles()

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Box className={classes.card}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography className={classes.cardTitle}>
                Perguntas frequentes
              </Typography>
            </Grid>

            {FAQ_TOPICS.map(({ topic, faqs }) => (
              <Grid item xs={12} key={topic}>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <Typography className={classes.topicTitle}>
                      {topic}
                    </Typography>
                  </Grid>

                  <Grid item xs={12}>
                    <ImportantInfo faqs={faqs} />
                  </Grid>
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Grid>
    </Grid>
  )
}

export default Help
